import { z } from 'zod';

/**
 * 公開終了タブ（読み取り専用）の URL search スキーマ。
 * 絞り込みはフリーテキストのみ（公開範囲フィルタは持たない）。
 */
export const ProductPublishEndedFilterSchema = z.object({
  freeText: z.string().optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100)
});